import styles from "./RenderLoader.module.css";

const RenderLoader = () => {
  return (
    <div className={styles.container}>
      <div className={styles.innerContainer}>
        <div className={styles.loader} />
      </div>
    </div>
  );
};

export default RenderLoader;
